import axios from 'axios';
import store from '../../store';
import { LOGOUT } from '../../actions/types';

export function authDebug(label, payload = {}) {
  // Authentication diagnostics are useful during local development, but
  // retaining request metadata in a browser session or console is an
  // unnecessary production disclosure surface. Keep the helper inert in
  // production while preserving the existing development troubleshooting
  // workflow.
  if (node_environment === "production") return;

  const entry = {
    at: new Date().toISOString(),
    label,
    payload
  };

  try {
    sessionStorage.setItem("license.auth.debug.last", JSON.stringify(entry));
    const history = JSON.parse(sessionStorage.getItem("license.auth.debug.history") || "[]");
    history.push(entry);
    sessionStorage.setItem("license.auth.debug.history", JSON.stringify(history.slice(-25)));
  } catch (_err) {

  }

  console.log(`[license-auth] ${label}`, payload);
}

export const node_environment =
  process.env.REACT_APP_DEVELOPMENT_MODE ||
  process.env.REACT_APP_NODE_ENV ||
  process.env.NODE_ENV ||
  "production";
export const development_mode = node_environment === "development";

const api_server_secure = !development_mode;
const api_server_address = development_mode ? "localhost" : "api.licensee.feradel.com";
const api_server_port = development_mode ? 10800 : 443;
const api_server_path = "api";

const login_address = development_mode ? "localhost" : "auth.licensee.feradel.com";
const login_port = development_mode ? 3000 : 443;
const login_secure = !development_mode;
const login_path = "";
const instance_uuid = "4bb4a951-84f6-41a8-8eb9-034def3c2138";

export function loginUrl() {
  return `http${login_secure ? "s" : ""}://${login_address}:${login_port}/${login_path}?i=${instance_uuid}`;
}

export function defaultUrl() {
         // http[s]://server:port/path
  return `http${api_server_secure ? "s" : ""}://${api_server_address}:${api_server_port}/${api_server_path}`;
}

export function url() {
         // http[s]://server:port/path
  if (localStorage.api) return `${localStorage.api}api`;
  return defaultUrl();
}

const api = axios.create({
  baseURL: url(),
  headers: {
    'Content-Type': 'application/json'
  }
});
/**
 intercept any error responses from the api
 and check if the token is no longer valid.
 ie. Token has expired or user is no longer
 authenticated.
 logout the user if the token has expired
**/
api.interceptors.request.use(
  cfg => {
    cfg.headers['x-auth-token'] = localStorage.token;
    authDebug("api:request", {
      method: cfg.method,
      url: cfg.url,
      baseURL: cfg.baseURL,
      hasToken: Boolean(localStorage.token)
    });
    return cfg;
  },
  err => {
    return Promise.reject(err);
  }
);

api.interceptors.response.use(
  res => {
    authDebug("api:response", {
      method: res.config?.method,
      url: res.config?.url,
      status: res.status
    });
    return res;
  },
  err => {
    authDebug("api:error", {
      method: err.config?.method,
      url: err.config?.url,
      baseURL: err.config?.baseURL,
      status: err.response?.status,
      data: err.response?.data
    });

    if (err && err.response && err.response.status === 401) {
      const requestUrl = err.config?.url || "";
      const canLogout = requestUrl === "/users/me";
      if (!canLogout) return Promise.reject(err);

      console.error("License API returned 401; logging out.", {
        method: err.config?.method,
        url: err.config?.url,
        baseURL: err.config?.baseURL,
        data: err.response?.data,
      });
      store.dispatch({ type: LOGOUT });
    }
    return Promise.reject(err);
  }
);

export default api;
